<div id="wrapper">
        <app-loading-screen status="true"></app-loading-screen>  
    <div class="allcont">
      <app-menu [tabActive]="this.tabActive"></app-menu>
      <app-loading-screen></app-loading-screen>
        <div class="basicrow mbott">
            <div class="container">
                <div class="fulltitle m-top-i f-btitle">
                    <img width="100%" class="userimgicon" src="../../assets/images/usersvicon.png"> Roles de Usuarios
                </div>

                <div *ngIf="this.sessionView==2">
                    <div class="basicrow m-top">
                            <div class="autowcont m-bott">
                                  <div class="basicrow msidespad">
                                  <div class="b-title">
                                      <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
                                          <div class="tabcell">
                                                Edición de roles
                                          </div>
                                      </div>
                                  </div>
                              </div>
                      
                              <div class="basicrow  m-bott msidespad">
                                  <div class="basicrow ">
                                    <div class="basicrow f-reg f-black m-top-u-i">
                                      <div class="basicrow text-justify">
                                        <span class="roboto-b f-med">Roles</span><br />
                                      </div>

                                      <div class="basicrow topbord">
                                          <select  class="sel-f" (change)="changeRole()" [(ngModel)]="selectRole"style="background-image:url(/assets/images/selectabarrw.png)">
                                            <option disabled value="">Seleccionar Rol</option>
                                            <option *ngFor ="let role of this.rolesList; let i = index" ng-value="role.name" >{{role.name}}</option>
                                          </select>
                                      </div>

                                      <div class="boxtbl m-top">
                                        <div class="tab-tbar">
                                          <div class="frwds permit-i rline vcenter">
                                            <div class="tabcell">
                                              Tipo de Permiso
                                            </div>
                                          </div>

                                          <div class="frwds permit-ii vcenter">
                                            <div class="tabcell">
                                              Estatus
                                            </div>
                                          </div>
                                        </div>

                                        <div class="permit">
                                          <div class="tab-cbar w-mob-a" *ngFor="let module of this.moduleData; let i = index" [ngClass]="{'': this.isOdd(i)!=1,' bg-gray':  this.isOdd(i)==1}">
                                            <div class="frwds permit-i rline vcenter mob-h-a">
                                              <div class="tabcell">
                                                <span class="roboto-b" [ngClass]="{'m-child': module.id_parent!=module.id_modulo,'': module.id_parent==module.id_modulo}">{{module.Modulo}}</span> <span class="m-desc-a">: {{module.description}}</span>
                                              </div>
                                            </div>

                                            <div class="frwds permit-ii vcenter">
                                              <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 left-switch-a">
                                                <label class="switch dig-def-i m-switch-a" >
                                                  <input type="checkbox" *ngIf="module.status==true" checked (click)="this.updCheck(i,!module.status);" >
                                                  <input type="checkbox" *ngIf="module.status!=true" (click)="this.updCheck(i,!module.status);">
                                                  <span class="slider"></span>
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                              </div>
                              <!-- <div class="basicrow m-top m-bott msidespad">
                                      <div class="basicrow topbord">
                                          <div class="basicrow f-reg f-black m-top-u-i">
                                              <div class="basicrow text-justify">
                                                  <span class="roboto-b f-med">Permisos</span><br/>
                                                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                                              </div>
                          
                                              <div class="boxtbl m-top">
                                                  <div class="tab-tbar">
                                                      <div class="frwds permit-i rline vcenter">
                                                          <div class="tabcell">
                                                              Tipo de Permiso
                                                          </div>
                                                      </div>
                          
                                                      <div class="frwds permit-ii vcenter">
                                                          <div class="tabcell">
                                                              Estatus
                                                          </div>
                                                      </div>
                                                  </div>
                          
                                                  <div class="permit">
                                                      <div class="tab-cbar w-mob-a" *ngFor="let module of this.moduleData; let i = index"  [ngClass]="{'': this.isOdd(i)!=1,' bg-gray':  this.isOdd(i)==1}">
                                                          <div class="frwds permit-i rline vcenter mob-h-a">
                                                              <div class="tabcell">
                                                                  <span class="roboto-b">{{module.name}}</span> <span class="m-desc-a">: {{module.description}}</span>
                                                              </div>
                                                          </div>
                          
                                                          <div class="frwds permit-ii vcenter">
                                                              <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 left-switch-a">
                                                              <label class="switch dig-def-i m-switch-a">
                                                                  <input type="checkbox" *ngIf="module.status=='True'" checked>
                                                                  <input type="checkbox" *ngIf="module.status!='True'">
                                                                  <span class="slider" ></span>
                                                              </label>
                                                              </div>
                                                          </div>
                                                      </div>
                                                  </div>
                                              </div>
                                          </div>
                                      </div>
                              </div> -->
                              <div class="basicrow m-bott msidespad">
                                  <div class="basicrow topbord">
                                      <div class="basicrow m-top-u-i">
                                          <a  class="btns def-i red pull-right vcenter" (click)="this.continue()">
                                              <span class="tabcell">
                                                  Continuar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                                              </span>
                                          </a>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                    
                </div>
                <div *ngIf="this.sessionView==3">
                  
                </div>
            </div>
        </div>
    </div>
  
    <app-footer></app-footer>
  </div>
